import "./radio-button.css";

const RadioButton = ({ id, name, title, checked, onChange }) => {
  return (
    <div className="radio-wrapper-11">
      <label className="radio-wrapper-11" htmlFor={id}>
        <input
          id={id}
          type="radio"
          name={name}
          checked={checked}
          onChange={onChange}
        />
        <span className="design"></span>
        <span className="text">{title}</span>
      </label>
    </div>
  );
};

export default RadioButton;
